module.exports = __webpack_public_path__ + "files/5fbbaa14682f92028bf00bf994d004a5.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/work.png
// module id = 939
// module chunks = 76